import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from 'pipes/translate.pipe';

@Pipe({
	name: 'phoneNumber'
})

export class PhoneNumberPipe implements PipeTransform {

	constructor(private readonly translate: TranslatePipe) { }

	transform(value: string): string {
		return value ?
			value.replace(/\s+/g, '').replace(/^(.*)(.{2})(.{2})(.{2})$/, '$1 $2 $3 $4') :
			this.translate.transform('general.na');
	}
}
